<template>
    <div class="modal fade show custom-modal" id="premiumChangedModal" :class="{'modal-show':showPremiumChangedModal}">
        <div class="modal-dialog modal-dialog-centered" role="document">
            <div class="modal-content">
                <div class="modal-head">
                    <button type="button" class="close" data-dismiss="modal" aria-label="Close" @click="closeModal(true)"  id="premium-changed-cross-close"> 
                        <img src="@/assets/images/popup-close.png" alt="X" />
                    </button>
                </div>
                <div class="modal-body text-center position-relative mt-2">
                    <div class="col-12 text-center mt-5 mb-5">
                        <p class="premium-desc mt-2">The Premium Amount has been changed to <span v-if="premiumAmount" class="font-weight-bold">₹{{premiumAmount}}</span> 
                            <br>Do you want to Proceed?
                        </p>
                    </div>
                    <div class="bgc-button-grp text-center">
                        <button type="button" class="bgc-btn-primary" @click="callUpdatePayment()+closeModal()" data-dismiss="modal"  id="premium-changed-yes" >Yes</button>
                        <button type="button" class="bgc-btn-secondary ml-3" data-dismiss="modal" @click="closeModal(true)"  id="premium-changed-no">No</button>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
import { reactive } from '@vue/composition-api';
export default {
     name: 'DiscardQuoteModal',
     props: ['premiumAmount','showPremiumChangedModal'],
     setup(props,context){
        let state = reactive({
        });
        //methods
        function callUpdatePayment(){
            context.parent.updatePayment(true);
        }
        function closeModal(clearUpdatedPremAmount) {
            context.parent.closePremiumChangedModal(clearUpdatedPremAmount);
        }
        return{
            callUpdatePayment,
            closeModal
        }
    }
};
</script>
<style scoped>
.custom-modal {
    width: 100%;
    height: 100%;
    overflow: auto;
    background-color: rgba(0, 0, 0, 0.4);
    transform: scale(0);
}
.modal-show {
    display: block;
    transform: scaleY(0) scaleX(0);
    animation: unfoldIn 0.25s cubic-bezier(0.165, 0.84, 0.44, 1) forwards;
}
.modal-head{
    -ms-flex-negative:0;
    flex-shrink:0;
    margin: 9px 5px 1px 5px;
    justify-content:space-between;
}
.modal-body{
    overflow-y: auto;
}
.premium-desc{
    font-size: 19px;
}
</style>
